export default __webpack_public_path__ + "static/bub3-5d07cc47c5fa9a0e8d0e21ddb3ada7ae.png";